/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { b as __awaiter, c as __generator, _ as __assign } from '../../../tslib.es6-e01eabb2.js';
import { p as promiseWindVane } from '../../../promise-windvane-85486cec.js';
import '../../../index-f24a9ec1.js';
import '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';

/**
 * 是否开启系统push
 */
var cnGetPushEnabled = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, promiseWindVane('CNHybridPushNotifPermissionAlert', 'pushAlertEnabled')];
            case 1:
                res = _c.sent();
                if (res.success) {
                    return [2 /*return*/, (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false];
                }
                return [2 /*return*/, false];
        }
    });
}); };
// alert弹窗询问
var cnAlertAndPushSystem = function (options) {
    return promiseWindVane('CNHybridPushNotifPermissionAlert', 'showAlert', __assign({}, options));
};
// 菜鸟app激活监听
var onCnAppActive = function (cb) {
    var handleResume = function () {
        cb();
    };
    var eventName = 'WV.Event.APP.Active';
    document.addEventListener(eventName, handleResume, false);
    return function () { return document.removeEventListener(eventName, handleResume, false); };
};

// 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
function openSystemPush(options) {
    return __awaiter(this, void 0, void 0, function () {
        var success, fail, _a, _b, _c, cn, hasOpenSystemPush, doAlertPush;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    success = options.success, fail = options.fail, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
                    return [4 /*yield*/, cnGetPushEnabled()];
                case 1:
                    hasOpenSystemPush = _d.sent();
                    if (hasOpenSystemPush) {
                        success();
                        return [2 /*return*/];
                    }
                    doAlertPush = function () { return __awaiter(_this, void 0, void 0, function () {
                        var data;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, cnAlertAndPushSystem(__assign({ needAlert: true, tipText: '您是否同意开启系统通知？', ignoreTiredPeriod: true, channel: 'cn-uni-api' }, cn))];
                                case 1:
                                    data = _a.sent();
                                    if (!data.success) {
                                        fail({ errMsg: data === null || data === void 0 ? void 0 : data.message });
                                        return [2 /*return*/];
                                    }
                                    // app激活监听
                                    onCnAppActive(function () { return __awaiter(_this, void 0, void 0, function () {
                                        var isSystemPushOpen;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, cnGetPushEnabled()];
                                                case 1:
                                                    isSystemPushOpen = _a.sent();
                                                    if (isSystemPushOpen) {
                                                        success();
                                                    }
                                                    else {
                                                        fail({ errMsg: '未开启系统通知' });
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    doAlertPush();
                    return [2 /*return*/];
            }
        });
    });
}

export { openSystemPush as default };
